module.exports = __webpack_public_path__ + "static/img/5-4.1442e31.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/case/5-4.png
// module id = gzc7
// module chunks = 0